export * from './kid-form.component';
